module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_x-2-chapter-title"
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('a', {
    attrs: {
      "href": "#/section0004#Anchor"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('a', {
    attrs: {
      "href": "#/section0006#Anchor"
    }
  }, [_vm._v("Chapter 1    Seth Did It")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('a', {
    attrs: {
      "href": "#/section0007#Anchor"
    }
  }, [_vm._v("Chapter 2    A Tangled Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0008#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3    Cue Faye")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0009#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4    The House with Multiple Personalities")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0010#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5    Phantom Couple on Call")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-18"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.08em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6   Gaffers, Ghosts, and the Glassmakers’ Ball")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0012#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7    The Extraordinary Bookstore")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0013#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8    A Woman’s Work Is Never Done")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0014#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9    The Ghost House")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0015#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10  Don’t Let Susan Out")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11  Must Love Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0017#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12  Who Let the Dogs Out?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13  A Haunted Café, a Legend, and a Lake")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0019#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14  Paranormal Fan Club")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15  Addie on Patrol")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0021#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16  A Trio of Ghosts at the Orleans Inn")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0022#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17  Love Possessed")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0023#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18  The House on the Hill in Eastham")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0024#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19  The Obsessive-Compulsive Exhorter")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0025#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20  A Clean Sweep")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0026#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21  Noepe, the Enchanted Isle")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0027#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22  The Far Away Land")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23  The Pirate and His Would-Be Bride")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0029#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24  The Ghosts of the Whydah Expedition")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-17"
  }, [_c('span', {
    attrs: {
      "href": "#/section0031#Anchor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d94568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0005.vue
// module id = 69
// module chunks = 0